var _rect, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrazil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    rx: 8.5,
    fill: "#019C37"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.42342 3L0 8.5L8.42342 14L17 8.5L8.42342 3Z",
    fill: "#FEE000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38_73)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 7,
    height: 7,
    rx: 3.5,
    fill: "#002277"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 7.01402C5.22297 7.0674 10.5157 7.81679 13.9028 10.3873",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_73"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 7,
    height: 7,
    rx: 3.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrazil);
export default __webpack_public_path__ + "assets/media/brazil.4d76d99bbe792f0594a44f1ca5ae5317.svg";
export { ForwardRef as ReactComponent };